export default "__VITE_ASSET__9b11a034__"